import { gql } from '@apollo/client';
import { CHAIN_BASE_FRAGMENT } from './chain.fragments';
import { IMAGE_VARIANT_FRAGMENT } from './media.fragments';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';
import { QR_CODE_DESIGN_FRAGMENT } from './qrCodeDesig.fragments';

export const PRODUCT_LANGUAGE_CONFIG = gql`
  fragment languageConfigValues on ProductLanguageConfig {
    default
    enabled
  }
`;

export const PRODUCT_BASE_FRAGMENT = gql`
  fragment productBaseValues on Product {
    id
    title
    imageUrl
    articleNumber
    modifiedTimestamp
    slug
    publicUrl
    image {
      ...imageVariant
    }
    languageConfig {
      ...languageConfigValues
    }
    supplyChainId
  }
  ${PRODUCT_LANGUAGE_CONFIG}
  ${IMAGE_VARIANT_FRAGMENT}
`;

export const PRODUCT_FRAGMENT = gql`
  fragment productValues on Product {
    ...productBaseValues
    publishedLanguages
    createdTimestamp
    publicUrl
    publishedTimestamp
    firstPublishedTimestamp
    contentStatus
    status
    styledStatus @client
    styledProgress @client
    isArchived @client
    isDraft @client
    isPublished @client
    lastEditedLang @client
    defaultQrCode {
      id
      tag
      url
      design {
        ...qrCodeDesignValues
      }
    }
    notEnabledLanguages @client
    latestAction {
      action
      userName
    }
  }
  ${PRODUCT_BASE_FRAGMENT}
  ${QR_CODE_DESIGN_FRAGMENT}
`;

export const PRODUCT_WITH_BASE_CHAIN_FRAGMENT = gql`
  fragment productWithBaseChain on Product {
    ...productBaseValues
    connectedPartnerCompanies {
      ...basePartnerCompanyValues
    }
    latestSupplyChain {
      ...chainBaseValues
    }
  }
  ${PRODUCT_BASE_FRAGMENT}
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${CHAIN_BASE_FRAGMENT}
`;
